<template>
  <mini-card :value="'$'+totalPayoutsToSubmit" subtitle="To Submit" :previousValue="'$'+totalPayoutsToSubmitPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-clipboard-check text-primary"></i>
    </div>
    <template slot="footer">
      <center class="row ml-0">
        <button class="btn btn-primary col-6"
                @click="submitPayoutsForPayment()"
                v-tooltip.center-top="'Submit Payouts for Payment'">
          Submit
        </button>
        <Row-Selection-Checkbox class="col-6 ml-auto"
                                v-tooltip.center-top="'Exclude some Payouts from the Submission'"
                                :filter="{status: $store.getters.Payout._status.SUBMISSION_REQUESTED.value}">
          Exclude
        </Row-Selection-Checkbox>
      </center>
    </template>
  </mini-card>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
import MiniCard from './MiniCard.vue'
export default {
  name: 'Payouts-To-Submit-MiniCard',
  components: {
    MiniCard
  },
  methods: {
    submitPayoutsForPayment () {
      this.$store.dispatch('openModal', {name: 'Payouts Confirmation', mode: 'Submit'})
    }
  },
  computed: {
    totalPayoutsToSubmit () {
      return this.$store.getters.totalPayouts({status: Payout._status.SUBMISSION_REQUESTED})
    },
    totalPayoutsToSubmitPrevious () {
      return this.$store.getters.totalPayoutsPrevious({status: Payout._status.SUBMISSION_REQUESTED})
    }
  }
}
</script>

<style>

</style>